// extracted by mini-css-extract-plugin
export var wrapper = "filter-module--wrapper--Pv9qV";
export var filter = "filter-module--filter--PmBpn";
export var label = "filter-module--label--wmg1n";
export var items = "filter-module--items--GWMAF";
export var item = "filter-module--item--XnvFh";
export var input = "filter-module--input--3MwZ7";
export var checkbox = "filter-module--checkbox--0nAY7";
export var fadein = "filter-module--fadein--lGQCZ";